"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenants = exports.supportedTenants = void 0;
exports.supportedTenants = [
    'redBullBoraHansgrohe',
    'speedweekTenant',
    'wrcTenant',
];
exports.tenants = {
    redBullBoraHansgrohe: { spaces: ['pro-cycling'] },
    speedweekTenant: { spaces: ['speedweek'] },
    wrcTenant: { spaces: ['erc', 'wrc'] },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVuYW50Lm1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZGVscy90ZW5hbnQubW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxnQkFBZ0IsR0FBRztJQUM5QixzQkFBc0I7SUFDdEIsaUJBQWlCO0lBQ2pCLFdBQVc7Q0FDSCxDQUFBO0FBUUcsUUFBQSxPQUFPLEdBQW9DO0lBQ3RELG9CQUFvQixFQUFFLEVBQUUsTUFBTSxFQUFFLENBQUMsYUFBYSxDQUFDLEVBQUU7SUFDakQsZUFBZSxFQUFFLEVBQUUsTUFBTSxFQUFFLENBQUMsV0FBVyxDQUFDLEVBQUU7SUFDMUMsU0FBUyxFQUFFLEVBQUUsTUFBTSxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxFQUFFO0NBQ3RDLENBQUEifQ==